import PropTypes from 'prop-types';

import MelodyCarousel from 'components/common/MelodyCarousel';
import MelodyCardProduct from 'components/common/melodyCard/MelodyCardProduct';
import css from 'styles/components/landing/brandTrending.scss';
import marketplace from 'cfg/marketplace.json';

const { search: { msaImageParams } } = marketplace;

const BrandTrending = ({
  slotDetails,
  onTaxonomyComponentClick,
  slotHeartsData }) => {
  const { trending, monetateId } = slotDetails;
  if (trending) {
    const { results, filters: { brandNameFacet } } = trending;
    return (
      <div className={css.brandTrendingWrap} data-content-name={monetateId}>
        {results && <MelodyCarousel title={`${brandNameFacet[0]}: Selected For You`}>
          {results.map(product =>
            <MelodyCardProduct
              key={product.styleId}
              cardData={product}
              msaImageParams={msaImageParams}
              shouldLazyLoad={true}
              eventLabel="Trending Product"
              onComponentClick={onTaxonomyComponentClick}
              componentStyle="brandTrendingStyle"
              melodyCardTestId="trendingProduct"
              heartsData={slotHeartsData}
            />
          )}
        </MelodyCarousel>}
      </div>
    );
  }
  return null;
};

BrandTrending.contextTypes = {
  testId: PropTypes.func
};

export default BrandTrending;
